<mbs-modal [title]="'shared:computers.modals.backupAgentUpdateRequiredTitle' | i18next">
  <ng-container modal-body>
    <mbs-alert
      [type]="alertType"
      [icon]="true">
      {{ 'shared:computers.modals.backupAgentUpdateRequiredText' | i18next: { computerName } }}
      <a
        target="_blank"
        [helpLink]="'https://kb.msp360.com/kb10140'"
        [kbMode]="true">
        {{ 'shared:buttons.learnMore' | i18next }}
      </a>
    </mbs-alert>
  </ng-container>
  <ng-container modalFooter>
    <mbs-button
      [type]="'primary'"
      (click)="baseModal.save(true)">
      {{ 'shared:computers.modals.backupAgentUpdateRequiredButton' | i18next }}
    </mbs-button>
  </ng-container>
</mbs-modal>
